export default __webpack_public_path__ + "static/media/profile4.ccb729db.jpeg";